import MuiChip from "@mui/material/Chip"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import IconButton from "@mui/material/IconButton"
import cs from "classnames"
import { Option } from "../types"
import DoDisturbIcon from "@mui/icons-material/DoDisturb"

import styles from "./Chip.module.scss"

interface Props {
  option: Option
  enableNegationOptions?: boolean
  className?: string

  onDeleteClick: (option: Option) => void
  onNegationChange?: (option: Option, negative: boolean) => void
}

export const Chip = ({ enableNegationOptions, option, className, onDeleteClick, onNegationChange }: Props) => {
  const isNegativeOption = !!option.data?.negative
  const negationClassName = isNegativeOption ? styles.negativeOption : styles.positiveOption

  const handleDeleteClick = () => {
    onDeleteClick(option)
  }

  const handleToggleNegationClick = () => {
    const newNegative = isNegativeOption ? false : true

    onNegationChange?.(option, newNegative)
  }

  return (
    <MuiChip
      icon={
        enableNegationOptions ? (
          <IconButton size="small" className={styles.toggleOptionStateButton} onClick={handleToggleNegationClick}>
            {isNegativeOption ? <DoDisturbIcon /> : <CheckCircleOutlineIcon />}
          </IconButton>
        ) : undefined
      }
      label={option.label}
      key={option.value}
      onDelete={handleDeleteClick}
      className={cs(styles.root, negationClassName, className)}
    />
  )
}
